import { SearchablePicker } from "./searchable-picker"

export type ChildStatus = "nominated" | "unverified" | "verified" | "sponsored" | "graduated"

export interface ChildOption {
  id: string
  code: string
  firstName: string
  lastName: string
  classLevel: string
  school: string
  state: string
  status: ChildStatus
}

function childLabel(child: ChildOption) {
  const school = child.school || "No school assigned"
  return `${child.code} · ${child.firstName} ${child.lastName} · ${child.status} · ${school}`
}

export function ChildPicker({
  children,
  value,
  onChange,
  disabled = false,
}: {
  children: ChildOption[]
  value: string
  onChange: (childId: string) => void
  disabled?: boolean
}) {
  const selected = children.find((child) => child.id === value)

  return (
    <div>
      <SearchablePicker
        items={children}
        value={value}
        onChange={onChange}
        getLabel={childLabel}
        getSearchText={(child) => [child.code, child.firstName, child.lastName, child.classLevel, child.school, child.state, child.status].join(" ")}
        renderOption={(child) => (
          <>
            <span className="block font-medium">{childLabel(child)}</span>
            <span className="mt-0.5 block text-xs text-ink/50">{child.classLevel} · {child.state}</span>
          </>
        )}
        label="Child"
        placeholder="Optional child link"
        ariaLabel="Select child"
        searchLabel="Search children"
        searchPlaceholder="Search children..."
        emptyMessage="No children found."
        disabled={disabled}
      />
      {selected && <p className="mt-1 text-xs text-ink/50">{selected.classLevel} · {selected.state}</p>}
    </div>
  )
}
